import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from 'src/app/app.config';
import { Address, AddressElement, Articolo, DashboardMsg, Etichetta, GenericResponse, Sezionale } from 'src/app/entities/various';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  private e_invoiceUrl : string =  environment.url;
  //private e_invoiceUrl: string = AppConfig.settings.apiServer.url;

  constructor(private http: HttpClient) { }

  async getAddresses(id : string|number, params : HttpParams): Promise<GenericResponse> {
    return this.http.get(this.e_invoiceUrl +"/api/v1/users/" + id + "/addresses", {params: params})
                    .toPromise()
                    .then((data:any) => {
                      return data;
                    })
  }

  async getAddressById(userId : string|number, addressId : string|number): Promise<GenericResponse> {
    return this.http.get(this.e_invoiceUrl +"/api/v1/users/" + userId + "/addresses/" + addressId)
                    .toPromise()
                    .then((data:any) => {
                      return data;
                    })
  }

  async getNewAddress() : Promise<GenericResponse> {
    return this.http.get(this.e_invoiceUrl +"/api/v1/models/address/")
                    .toPromise()
                    .then((data:any) => {
                      return data;
                    })
  }

  async saveAddress(userId:string|number, address: any): Promise<GenericResponse> {
    return this.http.put(this.e_invoiceUrl +"/api/v1/users/" + userId + "/addresses/" + address.id, address)
                    .toPromise()
                    .then((data:any) => {
                      return data;
                    })
  }

  async salvaIndirizzo(userId: string|number, address: any): Promise<GenericResponse> {
    return this.http.post(this.e_invoiceUrl + '/api/v1/users/' + userId + '/rubrica/add', address)
      .toPromise()
      .then((data:any) => {
        return data;
      })
  }

  /*async saveNewAddress(userId:string|number, address: Address): Promise<GenericResponse> {
    return this.http.post(this.e_invoiceUrl +"/api/v1/users/" + userId + "/addresses", address)
                    .toPromise()
                    .then((data:any) => {
                      return data;
                    })
  }*/

  async deleteAddress(userId:any, addressId: any) : Promise<GenericResponse> {
    return this.http.delete(this.e_invoiceUrl +"/api/v1/users/" + userId + "/addresses/" + addressId)
                    .toPromise()
                    .then((data:any) => {
                      return data;
                    })
  }

  async getElencoPA(userId : string|number, filter : string|number): Promise<GenericResponse> {
    return this.http.get(this.e_invoiceUrl +"/api/v1/users/" + userId + "/addresses/search_pa/" + filter)
                    .toPromise()
                    .then((data:any) => {
                      return data;
                    })
  }

  async cercaPA(params : HttpParams): Promise<any> {
    return this.http.get(this.e_invoiceUrl +"/api/v1/rubrica/cerca_pa", {params: params})
      .toPromise()
      .then((data:any) => {
        return data;
      }
    )
  }


  async getSezionali(userId: string|number) : Promise<GenericResponse> {
    return this.http.get(this.e_invoiceUrl +"/api/v1/users/" + userId + "/sezionali")
                    .toPromise()
                    .then((data:any) => {
                      return data;
                    })
                    .catch((data:any) => {
                      if (data.status == 500) {
                        return false;
                      } else return data;
                    })

  }

  async saveSezionale(userId : string|number, sezionale : Sezionale) : Promise<GenericResponse> {
    return this.http.put(this.e_invoiceUrl +"/api/v1/users/" + userId + "/sezionali/" + sezionale.id, sezionale)
                    .toPromise()
                    .then((data:any) => {
                      return data;
                    })
  }

  async saveSezionaleConf(userId : string|number, sezionale : Sezionale) : Promise<GenericResponse> {
    return this.http.post(this.e_invoiceUrl +"/api/v1/users/" + userId + "/sezionali", sezionale)
                    .toPromise()
                    .then((data:any) => {
                      return data;
                    })
  }

  async getSezionale(userId : string|number, sezionaleId : string|number) : Promise<GenericResponse> {
    return this.http.get(this.e_invoiceUrl +"/api/v1/users/" + userId + "/sezionali/" + sezionaleId)
                    .toPromise()
                    .then((data:any) => {
                      return data;
                    })
  }

  async deleteSezionale(userId : string|number, sezionaleId : string|number) : Promise<GenericResponse> {
    return this.http.delete(this.e_invoiceUrl +"/api/v1/users/" + userId + "/sezionali/" + sezionaleId)
                    .toPromise()
                    .then((data:any) => {
                      return data;
                    })
  }

  async getItems(userId : string| number, params : HttpParams) : Promise<GenericResponse> {
    return this.http.get(this.e_invoiceUrl +"/api/v1/users/" + userId + "/articoli", {params: params})
                    .toPromise()
                    .then((data:any) => {
                      return data;
                    })
  }

  async saveNewItem(userId:string|number, item : Articolo) : Promise<GenericResponse> {
    return this.http.post(this.e_invoiceUrl +"/api/v1/users/" + userId + "/articoli", item)
                    .toPromise()
                    .then((data:any) => {
                      return data;
                    })
  }

  async saveItem(userId:string|number, item : Articolo) : Promise<GenericResponse> {
    return this.http.put(this.e_invoiceUrl +"/api/v1/users/" + userId + "/articoli/" + item.id, item)
                    .toPromise()
                    .then((data:any) => {
                      return data;
                    })
  }

  async deleteItem(userId:string|number, itemId:string|number) : Promise<GenericResponse> {
    return this.http.delete(this.e_invoiceUrl +"/api/v1/users/" + userId + "/articoli/" + itemId)
                    .toPromise()
                    .then((data:any) => {
                      return data;
                    })
  }

  async getLabels(userId:string|number) : Promise<GenericResponse> {
    return this.http.get(this.e_invoiceUrl +"/api/v1/users/" + userId + "/label")
                    .toPromise()
                    .then((data:any) => {
                      return data;
                    })
  }

  async saveLabel(userId:string | number, label : Etichetta) : Promise<GenericResponse> {
    return this.http.put(this.e_invoiceUrl +"/api/v1/users/" + userId + "/label/" + label.id, label)
                    .toPromise()
                    .then((data:any) => {
                      return data;
                    })
  }

  async saveNewLabel(userId:string | number, label : Etichetta) : Promise<GenericResponse> {
    return this.http.post(this.e_invoiceUrl +"/api/v1/users/" + userId + "/label" , label)
                    .toPromise()
                    .then((data:any) => {
                      return data;
                    })
  }

  async deleteLabel(userId:string|number, labelId:string|number) : Promise<GenericResponse> {
    return this.http.delete(this.e_invoiceUrl +"/api/v1/users/" + userId + "/label/" + labelId)
                    .toPromise()
                    .then((data:any) => {
                      return data;
                    })
  }

  async getDashboard(userId:string | number) : Promise<GenericResponse> {
    return this.http.get(this.e_invoiceUrl +"/api/v1/users/" + userId + "/adminDashboard")
                    .toPromise()
                    .then((data:any) => {
                      return data;
                    })
  }

  async getDashboardMsg(userId:string | number, msgId : number|string) : Promise<GenericResponse> {
    return this.http.get(this.e_invoiceUrl +"/api/v1/users/" + userId + "/adminDashboard/" + msgId)
                    .toPromise()
                    .then((data:any) => {
                      return data;
                    })
  }

  async saveDashboardMsg(userId:string | number, msg : DashboardMsg) : Promise<GenericResponse> {
    return this.http.put(this.e_invoiceUrl +"/api/v1/users/" + userId + "/adminDashboard/" + msg.id_dashboard, msg)
                    .toPromise()
                    .then((data:any) => {
                      return data;
                    })
  }

  async deleteDashboardMsg(userId:string | number, msgId : number|string) : Promise<GenericResponse> {
    return this.http.delete(this.e_invoiceUrl +"/api/v1/users/" + userId + "/adminDashboard/" + msgId)
                    .toPromise()
                    .then((data:any) => {
                      return data;
                    })
  }

  async saveNewDashboardMsg(userId:string | number, msg : DashboardMsg) : Promise<GenericResponse> {
    return this.http.post(this.e_invoiceUrl +"/api/v1/users/" + userId + "/adminDashboard", msg)
                    .toPromise()
                    .then((data:any) => {
                      return data;
                    })
  }

  
}
